import * as API from './apiBase';

let baseList = {
    Index: 'api/Login/Index',
    Authorize: 'auth/token'
};

/*跳转认证中心 */
export const Index = () => {
    return API.GET(baseList.Index);
};

/*认证中心跳转 */
export const Authorize = params => {
    console.log(params, 'params');
    let addUrl = `?Code=${params.code}&State=${params.state}&CompanyCode=${params.company}&Language=${params.language}`
    return API.POST(baseList.Authorize + addUrl, `username=&password=&grant_type=password&CompanyCode=000`);
};
